import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router"
import { Layout, Table, Tooltip, Button, Modal, Checkbox, Alert } from "antd";
import { Header, ContentEx as Content, Footer, FunctionTitle, CommonMessage, FooterButtonArea } from "../../core/CorePageContents"
import styles from "./WorkerAttendanceDetail.module.css";
import * as Module from "../../../modules/prime/workerAttendance/workerAttendanceModule";
import * as Model from "../../../modules/prime/workerAttendance/workerAttendanceModel";
import { initMessages } from "../../../modules/core/commonMessageModule";
import * as messagesUtils from '../../../utils/messagesUtils';
import * as formatUtils from "../../../utils/formatUtils";
import * as constantsUtils from '../../../utils/constantsUtils';
import * as CONSTANTS from "../../../constants/constants";
import moment, { Moment } from "moment";
import { AuthButton } from "../../core/CoreForm";
import { LeftSquareFilled, RightSquareFilled, QuestionCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import AuthButtonStyles from "../../core/css/AuthButton.module.css";
import { initApiResult, storedApiResult, setApiResult } from "../../../modules/core/bffApiModule";

import { AbolishCompanyListButton } from '../../core/parts/AbolishCompanyListButton'
import { MergeCompanyAnnotations } from '../../core/parts/MergeCompanyAnnotations'
import { ForceApprovalAnnotations } from '../../core/parts/ForceApprovalAnnotations'
import { putLoginUserInfoAlertAsync, setLoginUserInfo, storedLoginUserInfo } from "../../../modules/core/authModule";
import { CcusLevelLabel } from '../../core/parts/CcusLevelLabel'


// チェックボックス
const CHECKBOX_CHECK = "1";
let sumAllProjectColSpan: number;
let qualificationDaysColSpan: number;

interface titleInterface {
  title: string;
}

export const WorkerAttendanceDetail = (props: titleInterface) => {

  const dispatch = useDispatch();
  let dataList = useSelector(Module.storedDetailDataList);
  let criteria = useSelector(Module.storedDetailCriteria);
  let summaryCriteria = useSelector(Module.storedCriteria);
  let total = useSelector(Module.storedDetailTotal);
  let belongCompanyId = useSelector(Module.storedCompanyId);
  let belongCompanyName = useSelector(Module.storedCompanyName);
  let workerId = useSelector(Module.storedWorkerId);
  let name = useSelector(Module.storedName);
  let ccusLevel = useSelector(Module.storedCcusLevel);
  let ccusErrorFlag = useSelector(Module.storedCcusErrorFlag);
  let primeCertificationNo = useSelector(Module.storedPrimeCertificationNo);
  let managementGroupName = useSelector(Module.storedManagementGroupName);
  let qualificationListTotal = useSelector(Module.storedQualificationListTotal);
  let qualificationListSubmit = useSelector(Module.storedQualificationListSubmit);
  let apiResult = useSelector(storedApiResult);
  let qualificationModalVisibleState = useSelector(Module.storedQualificationModalVisibleState);
  let projectId = useSelector(Module.storedProjectId);
  let checkApprovalConfirmAuthUserModalVisibleState = useSelector(Module.storedCheckApprovalConfirmAuthUserModalVisibleState);
  let authDataList = useSelector(Module.storedAuthDataList);
  let projectName = useSelector(Module.storedModalTitleProjectName);
  let statusConfirmed = useSelector(Module.storedStatusConfirmed);
  let apDupFlag = useSelector(Module.storedApDupFlag);
  let loginUserInfo = useSelector(storedLoginUserInfo);
  let history = useHistory();

  useEffect(() => {
    callGetDetailDataListApi();
  },
    [criteria]
  );

  // 建退共列の表示制御のため、「全プロジェクト合算」「資格名」行のcolSpanの値を画面表示時に設定する
  useEffect(() => {
    if (loginUserInfo.isMutualAidAvailableUserFlag === "1") {
      sumAllProjectColSpan = 8;
      qualificationDaysColSpan = 6;
    } else {
      sumAllProjectColSpan = 7;
      qualificationDaysColSpan = 5;
    }
  })

  /**
   * 一次協力会社名の一覧の整形
   * @param text 
   * @param row 
   */
  const renderfirstPartnerCompanyName = (text: string, row: Model.WorkRecordWorkerDetailRow) => {
    if (row.displayDivision === "0") {
      let firstPartnerCompanyNames: Array<any> = [];
      let promptTextList: Array<any> = [];

      let index = 0;
      row.firstPartnerCompanyList.forEach((partnerRow: Model.FirstPartnerCompanyRow) => {
        if (row.firstPartnerCompanyList.length >= 4 && index === 2) {
          // 一次協力会社が4つ以上ある場合、3件目以降は「...」で表示する
          firstPartnerCompanyNames.push(<div key={row.belongCompanyId + index} className={styles.leftText}>...</div>);
        } else if (row.firstPartnerCompanyList.length < 4 || index < 3) {
          firstPartnerCompanyNames.push(
            <div key={row.belongCompanyId + index} className={styles.leftText}>{partnerRow.firstPartnerCompanyName}</div>
          );
        }

        // Tooltipに表示するメッセージの作成
        promptTextList.push(<div>{partnerRow.firstPartnerCompanyName}</div>);
        index++;
      });

      if (row.firstPartnerCompanyList.length >= 4) {
        return {
          children: (<Tooltip placement="topLeft" title={promptTextList}><div className={styles.leftText}>{firstPartnerCompanyNames}</div></Tooltip>)
        }
      } else {
        return {
          children: firstPartnerCompanyNames
        }
      }
    } else {
      return (
        {
          props: {
            colSpan: 0,
          },
        }
      )
    }
  };

  /**
   * 月末の日付の取得
   * @param attendanceYearMonth 
   */
  const getLastDay = (attendanceYearMonth: string) => {
    // 年
    let year = parseInt(attendanceYearMonth.substring(0, 4));

    // 月
    let month = parseInt(attendanceYearMonth.substring(4, 6));

    return new Date(year, month, 0).getDate();
  }

  /**
   * 日毎の勤務実績の作成
   * @param attendanceYearMonth 
   */
  const getDaily = (attendanceYearMonth: string) => {
    let daysColumn = [];

    // 年
    let year = parseInt(attendanceYearMonth.substring(0, 4));

    // 月
    let month = parseInt(attendanceYearMonth.substring(4, 6));

    // 月の最終日の取得
    let lastDay = getLastDay(attendanceYearMonth);

    // 曜日文字列定義
    const weekDayChars = ["日", "月", "火", "水", "木", "金", "土"]

    for (let i = 1; i <= lastDay; i++) {
      // 日付オブジェクトの作成
      let day = new Date(year, month - 1, i);

      daysColumn.push(
        {
          title: i,
          dataIndex: "day" + i,
          key: "day" + i,
          className: styles.day,
          align: "center" as "center",
          children: [{
            title: weekDayChars[day.getDay()],
            className: styles.day,
            align: "center" as "center",
            onCell: () => ({
              style: {
                minWidth: "40px"
              }
            }),
            render: (test: string, row: Model.WorkRecordWorkerDetailRow) => {
              // プロジェクトのデータを表示
              if (row.displayDivision === "0") {
                // プロジェクト明細を表示
                if (isNotSubmitted(row)) {
                  if (i === 1) {
                    return (
                      {
                        props: {
                          colSpan: getLastDay(criteria.attendanceYearMonth)
                        },
                        children: (<div>未受領</div>)
                      }
                    )
                  } else {
                    return (
                      {
                        props: {
                          colSpan: 0
                        },
                      }
                    )
                  }
                } else if (isStatusForceApprovedFromNotSubmitted(row)) {
                  if (i === 1) {
                    return (
                      {
                        props: {
                          colSpan: getLastDay(criteria.attendanceYearMonth)
                        },
                        children: (<div>未受領の勤怠を外部承認しました。</div>)
                      }
                    )
                  } else {
                    return (
                      {
                        props: {
                          colSpan: 0
                        },
                      }
                    )
                  }
                } else {

                  // 労働時間の取得
                  let workingTime = formatUtils.formatTime(row.dailyWorkStatusList[i - 1].workingTime);
                  let isValid = isValidPeriod(row.dailyWorkStatusList[i - 1].meetQualificationRequirementType);
                  let currentMoment: Moment = moment(row.dailyWorkStatusList[i - 1].workingTime, ["HH:mm", moment.ISO_8601])
                  let isDupCell = row.dailyWorkStatusList[i - 1].dailyApDupFlag == CONSTANTS.ATTENDANCE_PERFORMANCE_DUPLICATE.ON.code;

                  if (isValid) {
                    return (
                      <>
                        <div className={`${styles.working} ${isDupCell ? styles.dupCell : ""}`}>{workingTime === "" || workingTime === "0:00" ? <>&nbsp;</> : workingTime}</div>
                      </>
                    )
                  } else {
                    return {
                      children: <span className={styles.invalidQualificationOutside}>{"対象外"}</span>,
                      props: {
                        className: styles.invalidQualification,
                      }
                    }
                  }
                }
                // 労働時間の合算行を表示
              } else if (row.displayDivision === "1") {
                // 労働時間合算行を表示
                let momentSummary: Moment = moment({ hours: 0, minutes: 0 });
                let isValid: boolean = false;
                let existSubmitted = false;
                dataList.forEach(row => {
                  if (row.displayDivision === "0") {
                    // 未確認（提出済）、未承認（確認済）、承認済、外部承認（未確認（提出済）、未承認（確認済）から承認）が合算対象
                    if (!isNotSubmitted(row) && !isStatusForceApprovedFromNotSubmitted(row)) {

                      // 労働時間の取得
                      let isValidDay = isValidPeriod(row.dailyWorkStatusList[i - 1].meetQualificationRequirementType)
                      if (isValidDay) {
                        let currentMoment: Moment = moment(row.dailyWorkStatusList[i - 1].workingTime, ["HH:mm", moment.ISO_8601])
                        // 重複あり かつ すでに計算済みの場合は加算しない
                        momentSummary.add("h", currentMoment.hour()).add("m", currentMoment.minute())

                        isValid = true; // 一つでも有効な日があったので、日別の合算行は「対象外」ではない
                      }
                      existSubmitted = true;
                    }
                  }
                });

                if (existSubmitted === false) {
                  // すべて未受領（未提出）の場合、日別の労働時間の合計は0とする
                  momentSummary = moment({ hours: 0, minutes: 0 });

                  // すべて未受領（未提出）の場合、日別の合算行は空白
                  isValid = true;
                }

                if (isValid) {
                  let today = moment({ hours: 0, minutes: 0 });
                  return (
                    <>
                      <div className={styles.working}>{momentSummary.day() == today.day() && momentSummary.hour() === 0 && momentSummary.minute() === 0 ? <>&nbsp;</> : momentSummary.diff(today, 'hours') + ":" + ("0" + momentSummary.minute()).slice(-2)}</div>
                    </>
                  )
                } else {
                  return {
                    children: <span className={styles.invalidQualificationOutside}>{"対象外"}</span>,
                    props: {
                      className: styles.invalidQualification,
                    }
                  }
                }
                // 資格のデータを表示
              } else if (row.displayDivision === "2") {
                // 資格行を表示
                let isValid: boolean = false;
                isValid = isValidPeriod(row.dailyQualificationRequirementList[i - 1].matchFlag)

                if (isValid) {
                  return (
                    <>
                      <div className={styles.working}>{row.dailyQualificationRequirementList[i - 1].matchFlag === "0" ? <>&nbsp;</> : "〇"}</div>
                    </>
                  )
                } else {
                  return {
                    children: <span className={styles.invalidQualificationOutside}>{"対象外"}</span>,
                    props: {
                      className: styles.invalidQualification,
                    }
                  }
                }
              }
            },
          }]
        }
      );
    }
    return daysColumn;
  }

  /** 有効期間内かどうか */
  const isValidPeriod = (type: string) => {
    return type !== CONSTANTS.QUALIFICATION_REQUIREMENT_TYPE.OUTSIDE_VALID_PERIOD.code;
  }

  /** 未受領（未提出）かどうかチェック */
  const isNotSubmitted = (row: Model.WorkRecordWorkerDetailRow) => {
    return isStatusNotSubmitted(row) || isStatusRemand(row);
  }

  /** 外部承認（未受領（未提出）、差戻から承認）かどうかチェック */
  const isStatusForceApprovedFromNotSubmitted = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_ON && (row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED || row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_REMAND);
  }

  /** 外部承認かどうかチェック */
  const isStatusForceApproved = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_ON;
  }

  /** 承認済かどうかチェック */
  const isStatusApproved = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_APPROVED;
  }

  /** 未承認（確認済）かどうかチェック */
  const isStatusConfirmed = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_CONFIRMED;
  }

  /** 差戻かどうかチェック */
  const isStatusRemand = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_REMAND;
  }

  /** 未受領（未提出）かどうかチェック */
  const isStatusNotSubmitted = (row: Model.WorkRecordWorkerDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED;
  }

  /** 重複有無チェック */
  const isApDup = (): boolean => {
    return apDupFlag == CONSTANTS.ATTENDANCE_PERFORMANCE_DUPLICATE.ON.code
    && !loginUserInfo.hiddenAlertPrimeCompanyIdList[CONSTANTS.HIDDEN_ALERT.AttendanceDuplicate].includes(loginUserInfo.belongCompanyId)
  }

  /**
   * 勤怠重複アラートを×ボタンで閉じたときの処理
   */
  const closeAttendanceDuplicateAlert = () => {
    const params = {
      primeCompanyId: loginUserInfo.belongCompanyId
      , hiddenAlertIdx: CONSTANTS.HIDDEN_ALERT.AttendanceDuplicate
    };
    // セッションのユーザ情報のアラート非表示元請企業IDリストに追加する
    dispatch(putLoginUserInfoAlertAsync(params, loginUserInfo));
  }

  /**
   * CriteriaをStoreに保持
   * @param keyValueList 
   */
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.WorkRecordWorkerDetailCriteria = {
      processType: criteria.processType,
      attendanceYearMonth: criteria.attendanceYearMonth,
      projectId: projectId,
      projectName: criteria.projectName,
      workerId: workerId,
      belongCompanyId: belongCompanyId,
      belongCompanyName: criteria.belongCompanyName,
      belongCompanyNameKana: criteria.belongCompanyNameKana,
      primeCertificationNo: criteria.primeCertificationNo,
      lastName: criteria.lastName,
      firstName: criteria.firstName,
      lastNameKana: criteria.lastNameKana,
      firstNameKana: criteria.firstNameKana,
      firstPartnerCompanyName: criteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: criteria.firstPartnerCompanyNameKana,
      status: criteria.status,
      hasWorkTime: criteria.hasWorkTime,
      offset: criteria.offset,
      limit: criteria.limit,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setDetailCriteria(newCriteria));
  }

  /** 外部urlからの遷移かチェック*/
  if (window.location.search !== "" && criteria.attendanceYearMonth === "" && belongCompanyId === "" && workerId === 0) {
    let urlParamStr = window.location.search.substring(1);

    let attendance_year_month = "";
    let belong_company_id = "";
    let worker_id = "";
    urlParamStr.split("&").forEach(param => {
      const temp = param.split("=");

      if (temp[0] === "attendanceYearMonth") {
        attendance_year_month = temp[1];
      } else if (temp[0] === "belongCompanyId") {
        belong_company_id = temp[1];
      } else if (temp[0] === "workerId") {
        worker_id = temp[1];
      }
    });

    // URLパラメータが全て入力されていない場合は上書きしない
    if (attendance_year_month !== "" &&
      belong_company_id !== "" &&
      worker_id !== "") {
      let urlParamValues: Model.UrlParameter = {
        belongCompanyId: belong_company_id
        , workerId: worker_id
        , attendanceYearMonth: attendance_year_month
      }
      dispatch(Module.setUrlParameterValue(urlParamValues));
    } else {
      history.push(CONSTANTS.PATH_PRIME_WORKERS_ATTENDANCE_SUMMARY);
    }
  } else if (window.location.search === ""
    && belongCompanyId === ""
    && workerId === 0
    && criteria.attendanceYearMonth === "") {
    history.push(CONSTANTS.PATH_PRIME_WORKERS_ATTENDANCE_SUMMARY);
  }

  /** 外部承認？ツールチップ */
  const ForceApprovalTooltip = (row: Model.WorkRecordWorkerDetailRow) => {
    return <ForceApprovalAnnotations isStatusForceApproved={isStatusForceApproved(row)} />
  }

  /** 一覧部 */
  let columns = [
    {
      title: "表示項目",
      align: "center" as "center",
      render: (text: string, row: Model.WorkRecordWorkerDetailRow, index: number) => {
        if (index === 0) {
          // データの行数分で表示
          return (
            {
              props: {
                rowSpan: total,
                align: "center",
                className: styles.displayItem,
              },
              children: (
                <>
                  <div>プロジェクト別</div>
                  <div>勤務時間</div>
                </>
              )
            }
          )
        } else if (index < total) {
          // データの表示をしない
          return (
            {
              props: {
                rowSpan: 0,
                className: styles.displayItem,

              },
            }
          )
          // 労働時間の合算行を表示
        } else if (row.displayDivision === "1") {

          return (
            {
              props: {
                colSpan: sumAllProjectColSpan,
                className: styles.displayItem,

              },
              children: (
                <>
                  <div className={styles.leftText}>全プロジェクト合算</div>
                </>
              )
            }
          )
          // 資格のデータを表示
        } else if (row.displayDivision === "2") {
          if (index === total + 1) {
            // 資格データの行数分で表示
            return (
              {
                props: {
                  rowSpan: qualificationListTotal,
                },
                children: (
                  <>
                    <div>資格別該当日数</div>
                  </>
                )
              }
            )
          } else {
            // 表示しない
            return (
              {
                props: {
                  rowSpan: 0,
                },
              }
            )
          }
        }
      },
    },
    {
      title: (
        <>
          <div>支店</div>
        </>
      ),
      className: styles.branchName,
      align: "center" as "center",
      width : "30px",
      colSpan: 2,
      render: (text: string, row: Model.WorkRecordWorkerDetailRow, index: number) => {
        // プロジェクトのデータを表示
        if (row.displayDivision === "0") {
          return (
            {
              props: {
                colSpan: 2,
              },
              children: (
                <>
                  <span className={styles.leftText}>{row.branchName}</span>
                </>
              )
            }
          )
          // 労働時間の合算行を表示
        } else if (row.displayDivision === "1") {
         
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
          // 資格のデータを表示
        } else if (row.displayDivision === "2") {
          if (index === total + 1) {
            // 資格データの行数分で表示
            return (
              {
                props: {
                  rowSpan: qualificationListTotal,
                  className: styles.loupeCell
                },
                children: (
                  <Button
                    name={"保持資格"}
                    onClick={() => onClickQualification(row)}
                    className={styles.materialSearchButton}
                  >
                    <i className="material-icons">search</i>
                  </Button>
                )
              }
            )
          } else {
            // 表示しない
            return (
              {
                props: {
                  rowSpan: 0,
                },
              }
            )
          }
        }
      }
    },
    {
      className: styles.branchName,
      colSpan: 0,
      render: (text: string, row: Model.WorkRecordWorkerDetailRow) => {
        if (row.displayDivision === "2") {
          return (
            {
              props: {
                colSpan: qualificationDaysColSpan,
              },
              children: (
                <>
                  <div className={styles.leftText}>{row.originalQualificationName}</div>
                </>
              )
            }
          )
        } else {
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
        }
      }
    },
    {
      title: (
        <>
          <div>プロジェクト名/</div>
          <div>独自資格名</div>
        </>
      ),
      className: styles.projectName,
      align: "center" as "center",
      colSpan: 1,
      render: (text: string, row: Model.WorkRecordWorkerDetailRow, index: number) => {
        // プロジェクトのデータを表示
        if (row.displayDivision === "0") {
          return (
            {
              props: {
                colSpan: 1,
              },
              children: (
                <>
                  <span className={styles.leftText}>{row.projectName}</span>
                  <AbolishCompanyListButton historyId={row.workRecordSubmissionHistoryId} abolishCompanyFlag={row.companyMergedAttendanceFlag} />
                </>
              )
            }
          )
          // 労働時間の合算行を表示
        } else if (row.displayDivision === "1") {
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
          // 資格のデータを表示
        } else if (row.displayDivision === "2") {
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
        }
      }
    },
    {
      title: "状態",
      className: styles.status,
      align: "center" as "center",
      render: (text: string, row: Model.WorkRecordWorkerDetailRow) => {
        // プロジェクトのデータを表示
        if (row.displayDivision === "0") {
          let label = "";
          if (isStatusForceApproved(row)) {
            label = "外部承認";
          } else {
            switch (row.approvalStatus) {
              case CONSTANTS.ATTENDANCE_STATUS_APPROVED:
                label = "承認済"
                break;
              case CONSTANTS.ATTENDANCE_STATUS_CONFIRMED:
                label = "未承認"
                break;
              case CONSTANTS.ATTENDANCE_STATUS_UNAPPROVED:
                label = "未確認"
                break;
              case CONSTANTS.ATTENDANCE_STATUS_REMAND:
                label = "差戻"
                break;
              case CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED:
                label = "未受領"
                break;
            }
          }
          // 労働時間の合算行を表示
          if (isStatusConfirmed(row)) {
            // 未承認（確認済）の場合、確認日、確認者を表示
            return (
              <>
                <div className={styles.statusLayout}>
                  <span>{label}</span>
                    <Button
                      name={"担当者確認"}
                      onClick={() => onClickCheckApprovalConfirmAuthUser(row)}
                      className={styles.materialSearchButton}
                    >
                      <i className="material-icons">search</i>
                    </Button><br />
                </div>
                <span>({formatUtils.formatDateSlash(row.confirmDate)})</span><br />
                <span>{row.confirmName}</span>
              </>)
          } else if (isStatusApproved(row) || isStatusForceApproved(row)) {
            // 承認済、外部承認の場合、承認日、承認者を表示
            return (
              <>
                <span>{label}</span>{ForceApprovalTooltip(row)}<br />
                <span>({formatUtils.formatDateSlash(row.approvalDate)})</span><br />
                <span>{row.approvalName}</span>
              </>)
          } else {
            return (
              <div className={styles.statusLayout}>
                <span>{label}</span>
                  <Button
                    name={"担当者確認"}
                    onClick={() => onClickCheckApprovalConfirmAuthUser(row)}
                    className={styles.materialSearchButton}
                  >
                    <i className="material-icons">search</i>
                  </Button>
              </div>)
          }
        } else {
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
        }
      }

    },
    {
      title: "一次協力会社",
      className: styles.firstPartner,
      align: "center" as "center",
      render: renderfirstPartnerCompanyName
    },
    {
      title: "作業次数",
      className: styles.topHierarchyLevel,
      align: "center" as "center",
      render: (text: string, row: Model.WorkRecordWorkerDetailRow) => {
        // プロジェクトのデータを表示
        if (row.displayDivision === "0") {
          return (
            <>
              <div className={styles.contentRight}>
                <span>{row.topHierarchyLevel}</span>
              </div>
            </>
          )
        } else {
          return (
            {
              props: {
                colSpan: 0,
              },
            }
          )
        }
      }
    },
    ...(loginUserInfo.isMutualAidAvailableUserFlag === "1" ?
      [{
        title: '建退共',
        className: styles.mutualAid,
        align: 'center' as 'center',
        render: (text: string, row: Model.WorkRecordWorkerDetailRow) => {
          // プロジェクトのデータを表示
          if (row.displayDivision === "0") {
            return (
              <>
                <div className={styles.contentCenter}>
                  <span className={row.mutualAidFlag === "1" ? "" : styles.nonMutualAid}>
                    {row.mutualAidFlag === "1" ? "〇" : "×"}
                  </span>
                </div>
              </>
            )
          } else {
            return (
              {
                props: {
                  colSpan: 0
                }
              }
            )
          }
        }
      }] : []
    ),
    {
      title: (
        <>
          <div>合計時間/</div>
          <div>資格要件該当日数</div>
        </>
      ),
      className: styles.item,
      align: "center" as "center",
      render: (text: string, row: Model.WorkRecordWorkerDetailRow) => {
        // プロジェクトのデータを表示
        if (row.displayDivision === "0") {
          return (
            <>
              <div className={styles.totalWorkingValue}>{row.totalWorkingTime}</div>
            </>
          )
          // 労働時間の合算行を表示
        } else if (row.displayDivision === "1") {
          return (
            <>
              <div className={styles.totalWorkingValue}>{row.summaryTotalWorkingTime}</div>
            </>
          )
          // 資格のデータを表示
        } else if (row.displayDivision === "2") {

          // 資格要件該当日数を求める
          let lastDay = getLastDay(criteria.attendanceYearMonth);
          let qualificationCount: number = 0;
          for (let i = 1; i <= lastDay; i++) {
            let isValid: boolean = false;
            isValid = isValidPeriod(row.dailyQualificationRequirementList[i - 1].matchFlag)
            qualificationCount += isValid ? row.dailyQualificationRequirementList[i - 1].matchFlag === "1" ? 1 : 0 : 0
          }

          return (
            <>
              <div className={styles.totalWorkingValue}>{qualificationCount + "日"}</div>
            </>
          )
        }
      }
    },
    {
      title: () => {
        let promptTextList: Array<any> = [];
        promptTextList.push(<div>〇…資格の適用条件（有効期間や次数等）を満たし、労働時間も満たしています。</div>);
        promptTextList.push(<div>対象外…資格の適用条件を満たしていません。</div>);
        promptTextList.push(<div>印なし…資格の適用条件を満たしていますが、労働時間を満たしていません。</div>);
        return (
          <div>労働者時間実績／資格要件該当状態
            <Tooltip
              overlayStyle={{ maxWidth: '1000px' }}
              placement="topLeft" title={promptTextList}>
              <span>&nbsp;
                <QuestionCircleFilled />&nbsp;
              </span>
            </Tooltip>
          </div>
        )
      },
      className: styles.workingRecordTitle,
      align: "center" as "center",
      children: getDaily(criteria.attendanceYearMonth)
    }
  ];

  // 有効期限を描画します。
  const renderDeadlineTerm = (value: string, row: Model.QualificationRow) => {
    return {
      children: (
        formatUtils.formatDuration(row.deadlineStartDate, row.deadlineEndDate)
      )
    }
  };

  /**
   * プロジェクト別（確認・承認）担当者一覧モーダルの表示
   */
  const checkConfirmApprovalAuthUserModalColumns = [
    
    {
      title: 'MCDP-ID'
      , width: '190px'
      , dataIndex: 'mcdpId'
      , align: 'center' as 'center'
      , render: (value: any, row: Model.checkApprovalConfirmAuthRow) => {
        return (
          <>
          <span>{row.mcdpId}</span>
          </>
        )
      }
    },
    {
      title: 'ユーザ名'
      , width: '200px'
      , dataIndex: 'userName' 
      , align: 'center' as 'center'
      , render: (value: any, row: Model.checkApprovalConfirmAuthRow) => {
        return (
          <>
            <span>{row.userName}</span>
          </>
        )
      }
    },
    {
      title: '確認担当者'
      , dataIndex: 'confirmAuth'
      , width: '200px'
      , align: 'center' as 'center'
      , render: (value: any, row: Model.checkApprovalConfirmAuthRow) => {
        return (
          <Checkbox
            defaultChecked={CHECKBOX_CHECK === row.confirmAuth ? true : false}
            style={CHECKBOX_CHECK === row.confirmAuth ? {} : { display: "none" }}
            disabled
          >
          </Checkbox>
        )
      }
    },
    {
      title: '承認担当者'
      , dataIndex: 'approvalAuth'
      , width: '200px'
      , align: 'center' as 'center'
      , render: (value: any, row: Model.checkApprovalConfirmAuthRow) => {
        return (
          <Checkbox
            defaultChecked={CHECKBOX_CHECK === row.approvalAuth ? true : false}
            style={CHECKBOX_CHECK === row.approvalAuth ? {} : { display: "none" }}
            disabled
          ></Checkbox> 
        ) 
      }
    }   
  ];

  // ステータスが「未承認」の時は、確認担当者欄を非表示にする
  if (statusConfirmed === CONSTANTS.ATTENDANCE_STATUS_CONFIRMED) {
    // 表示する一覧の３つ目確の認担当者欄を削除する
    checkConfirmApprovalAuthUserModalColumns.splice(2, 1);
  }

  /**
   * 資格一覧ダイアログの表示
   */
  const qualificationDialogColumns = [
    {
      title: '資格名'
      , width: '200px'
      , dataIndex: 'originalQualificationName'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.QualificationRow) => {
        return (
          <>
            <span>{row.originalQualificationName}</span>
          </>
        )
      }
    },
    {
      title: '対象次数'
      , width: '80px'
      , dataIndex: 'levelRangeTo'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          <>
            <span>{constantsUtils.getLabelOf(CONSTANTS.LEVEL_RANGE_TO, String(row.levelRangeTo))}</span>
          </>
        )
      }
    },
    {
      title: '対象プロジェクト'
      , width: '220px'
      , dataIndex: 'certificationProject'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          renderProjectName(row.certificationProjectName, row)
        )
      }
    },
    {
      title: '認定日'
      , width: '100px'
      , dataIndex: 'certificationDate'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          formatUtils.formatDateSlash(row.certificationDate)
        )
      }
    },
    {
      title: '有効期間'
      , width: '200px'
      , dataIndex: 'deadlineTerm'
      , align: 'left' as 'left'
      , render: renderDeadlineTerm
    }
  ];

  const callGetDetailDataListApi = () => {

    // パラメータがない場合はデータの取得を行わない
    if (belongCompanyId === ""
      || workerId === 0
      || criteria.attendanceYearMonth === "") {
      return;
    }

    let params: Model.getDetailDataList.Request = {
      processType: CONSTANTS.DETAIL_PROCESS_TYPE_PAYMENT,
      attendanceYearMonth: criteria.attendanceYearMonth,
      projectId: projectId,
      projectName: criteria.projectName,
      workerId: workerId,
      belongCompanyId: belongCompanyId,
      belongCompanyName: criteria.belongCompanyName,
      belongCompanyNameKana: criteria.belongCompanyNameKana,
      primeCertificationNo: criteria.primeCertificationNo,
      lastName: criteria.workerLastName,
      firstName: criteria.workerFirstName,
      lastNameKana: criteria.workerLastNameKana,
      firstNameKana: criteria.workerFirstNameKana,
      firstPartnerCompanyName: criteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: criteria.firstPartnerCompanyNameKana,
      status: criteria.status,
      hasWorkTime: criteria.hasWorkTime,
      offset: criteria.offset,
      limit: criteria.limit
    }
    dispatch(Module.getDetailDataListAsync(params));
  }

  /**
   * 戻るボタン押下
   */
  const onClickBack = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let newCriteria: Model.WorkRecordWorkerSummaryCriteria = {
      managementGroupId: summaryCriteria.managementGroupId,
      belongCompanyName: summaryCriteria.belongCompanyName,
      belongCompanyNameKana: summaryCriteria.belongCompanyNameKana,
      firstPartnerCompanyName: summaryCriteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: summaryCriteria.firstPartnerCompanyNameKana,
      lastName: summaryCriteria.lastName,
      firstName: summaryCriteria.firstName,
      lastNameKana: summaryCriteria.lastNameKana,
      firstNameKana: summaryCriteria.firstNameKana,
      fromYYYYMM: summaryCriteria.fromYYYYMM,
      toYYYYMM: summaryCriteria.toYYYYMM,
      hasWorkTime: summaryCriteria.hasWorkTime,
      isReSearch: "1",
      sortItem: summaryCriteria.sortItem,
      sortOrder: summaryCriteria.sortOrder,
      offset: summaryCriteria.offset,
      limit: summaryCriteria.limit,
    }
    dispatch(Module.setCriteria(newCriteria));

    history.push(CONSTANTS.PATH_PRIME_WORKERS_ATTENDANCE_SUMMARY);
  }


  /**
   * 勤怠年月変更日イベント
   * @param addValue 
   */
  const onChangeMonth = (addValue: number) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // API処理結果を初期化します。
    dispatch(initApiResult());

    let year = parseInt(criteria.attendanceYearMonth.substring(0, 4));
    let month = parseInt(criteria.attendanceYearMonth.substring(4, 6));

    // 変更後の日付インスタンスの作成
    let newDate = new Date(year, (month - 1) + addValue, 1);

    year = newDate.getFullYear();
    month = newDate.getMonth() + 1;

    criteriaDataTransfer([
      { key: "attendanceYearMonth", value: year.toString() + ("0" + month).slice(-2) }
    ]);
  }

  /** 技能レベルの表示 */
  const CcusLevel = () => {
    return <CcusLevelLabel ccusLevel={ccusLevel} ccusErrorFlag={ccusErrorFlag} />
  };

  /** 一覧ヘッダー部 */
  const AttendanceDetailHeader = () => {
    return (
      <div style={{ whiteSpace: "nowrap" }} className={styles.searchGroup}>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle}>勤怠年月：</div>
          <div>
            <label style={{ color: "#006a5d", margin: "4px" }} onClick={(e) => onChangeMonth(-1)}><LeftSquareFilled /></label>
            {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月
            <label style={{ color: "#006a5d", margin: "4px" }} onClick={(e) => onChangeMonth(1)}><RightSquareFilled /></label>
          </div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>所属会社：</div>
          <div>{belongCompanyName}</div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>独自資格認定支店：</div>
          <div>{managementGroupName}</div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>元請認定番号：</div>
          <div>{primeCertificationNo}</div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>氏名：</div>
          <div>{name}</div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>技能レベル：</div>
          {CcusLevel()}
        </div>
      </div>
    )
  }

  /** 一覧部 */
  const AttendanceContent = () => {
    if (total > 0) {
      return (
        <>
          <Table
            size="small"
            className="hoverNotBackground"
            sticky={{ offsetHeader : -31 }}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            rowClassName={(record, index) => {
              if (index === total) {
                return styles.rowRed
              } else if (index > total) {
                return styles.rowBlue
              }
              return "";
            }
            }
          >
          </Table>
        </>
      );
    } else {
      return <></>
    }
  }

  /** ボタン部 */
  const AttendanceButton = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          onClick={onClickBack}
          style={{ margin: "10px" }}
          className={AuthButtonStyles.backButtonFixed}
        />
      </FooterButtonArea>
    )
  }

  /**
   * 資格一覧ダイアログを表示
   * @param row 
   */
  const onClickQualification = async (row: Model.WorkRecordWorkerDetailRow) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // NowLoading表示
    dispatch(initApiResult());

    // API呼出引数
    let params: Model.getOriginalQualificationListSubmit.Request = {
      belongCompanyId: belongCompanyId,
      workerId: String(workerId),
      yearMonth: criteria.attendanceYearMonth,
    }

    // 同期でAPIを呼び出す（前に取得した値が画面に表示されないようにする）
    await dispatch(Module.getQualificationsHoldersPrimeQualificationListSubmitAsync(params));

    // 資格一覧ダイアログの表示
    dispatch(Module.reflectQualificationModalState(true));
  }

  /**
   * 資格一覧ダイアログの閉じるボタン押下
   */
  const onClickQualificationCancel = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // 資格一覧ダイアログを閉じる
    dispatch(Module.reflectQualificationModalState(false));
  }

  /** 資格一覧ダイアログ表示内容 */
  const QualificationModalContent = () => {
    // ダイアログ表示時の資格一覧取得API実行後、APIエラーメッセージが設定されているかどうか
    let isApiSuccess: boolean = CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode;
    if (isApiSuccess) {
      // API正常終了 
      return (
        <div className={styles.contentArea} >
          {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月提出時点で保持している資格一覧

          {qualificationListSubmit.length > 0 ?
            <Content
              style={{ margin: "auto", textAlign: "left" }}
              hasapicall={"false"}>
              <Table
                columns={qualificationDialogColumns}
                size='small'
                dataSource={qualificationListSubmit}
                pagination={false}
                className="hoverNotBackground"
                style={{ marginLeft: "20px" }}
                bordered
              />
            </Content> : <div className={styles.qualificationModalMessage}><ExclamationCircleOutlined className={styles.iconSize} style={{ marginRight: "6px" }} />保有資格はありません</div>
          }
        </div>
      );
    } else {
      // APIエラー有
      return (
        <div className={styles.contentArea} >
          {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月提出時点で保持している資格一覧
          <CommonMessage isModal={true} />
        </div>
      );
    }
  }
    
  /**
  * プロジェクト別（確認・承認）担当者一覧モーダルを表示
  * @param row
  */
  const onClickCheckApprovalConfirmAuthUser = async (row: Model.WorkRecordWorkerDetailRow) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // NowLoading表示
    dispatch(initApiResult());

    // 未承認ステータスのstate管理
    dispatch(Module.controlConfirmedDialog(row));

    // API呼出引数
    let params: Model.getApprovalConfirmAuthUserList.Request = {
      projectId: row.projectId,
      belongCompanyId: row.belongCompanyId,
      workerId: workerId
    }

    // 同期でAPIを呼び出す（前に取得した値が画面に表示されないようにする）
    await dispatch(Module.getProjectConfirmApprovalUserListAsync(params));

    // プロジェクト名のstate管理
    dispatch(Module.setModalProjectName(row));

    // プロジェクト別（確認・承認権限保持ユーザー）確認ダイアログを表示
    dispatch(Module.reflectCheckConfirmApprovalAuthUserModalState(true));
  }

  /** プロジェクト別（確認・承認）担当者一覧モーダルの表示内容 */
  const CheckapproverModalContent = () => {
    
    // モーダル表示時の担当者一覧取得API実行後、APIエラーメッセージが設定されているかどうか
    let isApiSuccess: boolean = CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode;
    if (isApiSuccess) {
      // API正常終了
    return (
      <div className={styles.contentArea} >
        { authDataList.length > 0 ? (
          <>
            <span>担当者一覧（{projectName}）</span><br />
            <span>※現時点での担当者情報です</span>  
            <Content
              style={{ margin: "auto", textAlign: "left" }}
              hasapicall={"false"}>
            <Table
              columns={checkConfirmApprovalAuthUserModalColumns}
              size='small'
              dataSource={authDataList}
              scroll={{ x: 700, y: 250 }}
              pagination={false}
              className="hoverNotBackground"
              style={{ marginLeft: "20px" }}
              bordered
            />
            </Content>
          </>
        ) : (
            <div><ExclamationCircleOutlined className={styles.iconSize} style={{ marginRight: "6px" }} />担当者が未設定です。
            <span className={styles.authUserListModalMessage}>確認や承認が必要な場合は、担当者を設定してください。</span></div>
            )}
      </div>
        );
       }
      return null;
    }
    

  /** プロジェクト別（確認・承認）担当者一覧モーダルを閉じる */
  const onClickCheckConfirmApprovalAuthUserCancel = () => {

    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // プロジェクト別（確認・承認）担当者一覧モーダルを閉じる
    dispatch(Module.reflectCheckConfirmApprovalAuthUserModalState(false));
  }

  /**
   * 対象プロジェクト一覧の整形
   * @param text 
   * @param row 
   * @returns 
   */
  const renderProjectName = (text: string, row: Model.QualificationRow) => {

    let projectNames: Array<any> = [];
    let promptTextList: Array<any> = [];
    const projectNameList: string[] = text.split(",");

    let index = 0;
    projectNameList.sort((a,b) => {
      return a > b ? 1 : -1
    }).forEach(projectName => {
      if (projectNameList.length >= 4 && index === 2) {
        // 対象プロジェクトが4件以上ある場合、3件目以降は「...」で表示する（...の行を含めてMAX3行）
        projectNames.push(<div className={styles.columnAlignLeft}>...</div>);
      } else if (projectNameList.length < 4 || index < 3) {
        // 15文字より多い場合、15文字目以降は「...」で表示する（...を含めてMAX15文字）
        projectNames.push(
          <div className={styles.columnAlignLeft}>{projectName.length > 15 ? projectName.substring(0,14) + "..." : projectName}</div>
        );
      }

      // Tooltipに表示するメッセージの作成
      promptTextList.push(<div>{projectName}</div>);
      index++;
    });

    if (text.length >= 1) {
      return (<Tooltip placement="left" title={promptTextList}><div>{projectNames}</div></Tooltip>)
    } else {
      return <div className={styles.columnAlignLeft}>{row.certificationProjectFlag === "1" ? "なし" : "すべてのプロジェクト"}</div>
    }
  };

  return (
    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        {
          !isApDup() ?
          <></>
          : <Alert
            message={
              <><div style={{fontWeight: "bold"}}>勤怠実績報告に入退場記録の重複が見つかりました。</div><div style={{fontWeight: "normal"}}>複数の編成下で編成ごとに同じ入退場時間が記録されています。<br />背景色と太字で強調表示された勤怠をご確認ください。</div></>
            }
            type='warning'
            showIcon
            closable
            style={{
              width: "fit-content"
              , marginTop: "40px"
              , marginBottom :"15px"
              , fontWeight: "bold"
              , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
              , textAlign: "left"
            }}
            onClose={closeAttendanceDuplicateAlert}
          />
        }
        {
          ccusErrorFlag === CONSTANTS.CCUS_ERROR_FLAG.ON ?
          <Alert
            message={
              <>
                <b>{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TITLE")}</b>
                <br />{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TEXT_PRIME")}
              </>
            }
            type='warning'
            showIcon
            closable
            style={{
              width: "fit-content"
              , marginTop: isApDup() ? "10px" : "40px"
              , marginBottom :"15px"
              , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
              , textAlign: "left"
            }}
          />
          : <></>
        }
        <CommonMessage />
        <AttendanceDetailHeader />
        <div style={{ float: "left" }}>「一次協力会社」の下で異なる複数の編成（次数）に入っている場合、「作業次数」欄にはもっとも上位の次数が表示されます。</div>
        <AttendanceContent />
        <MergeCompanyAnnotations
          attendanceList={dataList}
          mergeCompanyAttendanceFlgName={"companyMergedAttendanceFlag"}
        />
      </Content>
      <AttendanceButton />
      <Footer />

      {/* 資格一覧ダイアログ */}
      <Modal
        visible={qualificationModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={onClickQualificationCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={900}
      >
        <Layout>
          <QualificationModalContent />
        </Layout>
      </Modal>

      {/* プロジェクト別（確認・承認）担当者一覧モーダル */}
      <Modal
        visible={checkApprovalConfirmAuthUserModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={onClickCheckConfirmApprovalAuthUserCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={900} 
        >
        <Layout>
          <CheckapproverModalContent />
        </Layout>
      </Modal>
    </Layout>

  );
}


